import './App.css';
import Configuracoes from './components/Configuracoes';
import Relatorios from './components/Relatorios';
import Dashboard from './components/Dashboard';
import Sidebar from './components/Sidebar';
import Login from './components/Login';
import logo from './logo-rh-fenix-transparente.png';

import { useEffect, useRef, useState } from 'react';
import * as faceapi from 'face-api.js';

import {
  FiGrid,
  FiUsers,
  FiBriefcase,
  FiClock,
  FiFileText
} from 'react-icons/fi';

function App() {

  const videoRef = useRef(null);

  const [logado, setLogado] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState('');

  const [loginEmail, setLoginEmail] = useState('admin@rhfenix.com.br');
  const [loginSenha, setLoginSenha] = useState('');
  const [mensagemLogin, setMensagemLogin] = useState('');

  const [menu, setMenu] = useState('dashboard');

  const [modalAberto, setModalAberto] = useState(false);
  const [abaModal, setAbaModal] = useState('dados');

  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);

  const [colaboradores, setColaboradores] = useState([]);
  const [dashboard, setDashboard] = useState({
         colaboradores: 0,
         registrosHoje: 0,
         reconhecimentos: 0,
         ultimosRegistros: []
});

  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [matricula, setMatricula] = useState('');

  const [mensagem, setMensagem] = useState('');
  const [mensagemPonto, setMensagemPonto] = useState('');
  const [faceStatus, setFaceStatus] = useState(
     'Posicione seu rosto dentro da moldura'
);

  useEffect(() => {

    carregarModelos();

    const tokenSalvo = localStorage.getItem('rhfenix_token');
    const usuarioSalvo = localStorage.getItem('rhfenix_usuario');

    if (tokenSalvo && usuarioSalvo) {

      setToken(tokenSalvo);
      setUsuario(JSON.parse(usuarioSalvo));
      setLogado(true);

      carregarColaboradores(tokenSalvo);
    }

  }, []);

  async function carregarModelos() {

    try {

      await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
      await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
      await faceapi.nets.faceRecognitionNet.loadFromUri('/models');

      console.log('Modelos faciais carregados');

    } catch (error) {

      console.error(error);

    }
  }

  async function fazerLogin(e) {

    e.preventDefault();

    setMensagemLogin('Validando acesso...');

    try {

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: loginEmail,
            senha: loginSenha
          })
        }
      );

      const dados = await resposta.json();

      if (!dados.sucesso) {

        setMensagemLogin(
          dados.mensagem || 'Usuário ou senha inválidos.'
        );

        return;
      }

      localStorage.setItem(
        'rhfenix_token',
        dados.token
      );

      localStorage.setItem(
        'rhfenix_usuario',
        JSON.stringify(dados.usuario)
      );

      setToken(dados.token);
      setUsuario(dados.usuario);

      setLogado(true);

      setMensagemLogin('');

      carregarColaboradores(dados.token);

    } catch (error) {

      console.error(error);

      setMensagemLogin(
        'Erro ao conectar com o servidor.'
      );

    }
  }

  function sair() {

    localStorage.removeItem('rhfenix_token');
    localStorage.removeItem('rhfenix_usuario');

    setToken('');
    setUsuario(null);

    setLogado(false);
  }

  async function carregarColaboradores(tokenAtual = token) {

    try {

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/colaboradores',
        {
          headers: {
            Authorization: `Bearer ${tokenAtual}`
          }
        }
      );

      if (resposta.status === 401) {
        sair();
        return;
      }

      const dados = await resposta.json();

      if (dados.sucesso) {
        setColaboradores(dados.colaboradores);
      }

    } catch (error) {

      console.error(error);

    }
  }

  async function salvarColaborador(e) {

    e.preventDefault();

    setMensagem('Salvando colaborador...');

    try {

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/colaboradores',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            nome,
            cpf,
            email,
            matricula
          })
        }
      );

      const dados = await resposta.json();

      if (!dados.sucesso) {

        setMensagem(
          dados.mensagem || 'Erro ao salvar.'
        );

        return;
      }

      setNome('');
      setCpf('');
      setEmail('');
      setMatricula('');

      setMensagem('');

      setModalAberto(false);

      carregarColaboradores();

    } catch (error) {

      console.error(error);

      setMensagem('Erro ao conectar.');

    }
  }

  async function iniciarCamera() {

    try {

      setMensagemPonto('');

      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      });

      videoRef.current.srcObject = stream;

    } catch (error) {

      console.error(error);

      alert('Erro ao acessar câmera.');

    }
  }

  async function capturarFace() {

    try {

      const detection = await faceapi
        .detectSingleFace(
          videoRef.current,
          new faceapi.TinyFaceDetectorOptions()
        )
        .withFaceLandmarks()
        .withFaceDescriptor();

      if (!detection) {

        alert('Nenhum rosto detectado.');

        return;
      }

      const descriptor = Array.from(
        detection.descriptor
      );

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/face-template',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            colaborador_id: colaboradorSelecionado.id,
            face_descriptor: descriptor
          })
        }
      );

      const dados = await resposta.json();

      if (!dados.sucesso) {

        alert('Erro ao salvar biometria.');

        return;
      }

      alert(
        'Biometria facial cadastrada com sucesso.'
      );

      carregarColaboradores();

    } catch (error) {

      console.error(error);

      alert('Erro ao capturar biometria.');

    }
  }

  async function reconhecerFace() {

    try {

      setMensagemPonto(
        'Analisando reconhecimento facial...'
      );

      const detection = await faceapi
        .detectSingleFace(
          videoRef.current,
          new faceapi.TinyFaceDetectorOptions()
        )
        .withFaceLandmarks()
        .withFaceDescriptor();

      if (!detection) {
         setFaceStatus('Nenhum rosto detectado');
         setMensagemPonto('');
         return;
      }

         setFaceStatus('Face detectada');

      const descriptorAtual = detection.descriptor;

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/face-templates',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const dados = await resposta.json();

      if (!dados.sucesso) {

        setMensagemPonto(
          'Erro ao buscar biometrias.'
        );

        return;
      }

      const templates = dados.templates;

      let melhorMatch = null;
      let menorDistancia = 999;

      templates.forEach((template) => {

        const descriptorBanco = new Float32Array(
          JSON.parse(template.face_descriptor)
        );

        const distancia =
          faceapi.euclideanDistance(
            descriptorAtual,
            descriptorBanco
          );

        if (distancia < menorDistancia) {

          menorDistancia = distancia;
          melhorMatch = template;

        }
      });

      if (!melhorMatch || menorDistancia > 0.5) {

        setMensagemPonto(
          'Face não reconhecida.'
        );

        return;
      }

      const confianca = Number(
        (1 - menorDistancia).toFixed(4)
      );

      // =====================================
      // CAPTURAR SNAPSHOT
      // =====================================

      const canvas = document.createElement('canvas');

      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;

      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        videoRef.current,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const snapshot = canvas.toDataURL('image/png');

      // =====================================
      // REGISTRAR PONTO
      // =====================================

      const registro = await fetch(
        'https://ponto.rhfenix.com.br/api/registrar-ponto',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            colaborador_id: melhorMatch.colaborador_id,
            confianca,
            snapshot
          })
        }
      );

      const resultadoRegistro = await registro.json();

      if (!resultadoRegistro.sucesso) {

        setMensagemPonto(
          resultadoRegistro.mensagem ||
          'Erro ao registrar ponto.'
        );

        return;
      }

      setMensagemPonto(
        `Ponto registrado com sucesso: ${melhorMatch.nome} | Confiança: ${confianca}`
      );

    } catch (error) {

      console.error(error);

      setMensagemPonto(
        'Erro no reconhecimento facial.'
      );

    }
  }

  if (!logado) {

  return (
    <Login
      loginEmail={loginEmail}
      setLoginEmail={setLoginEmail}
      loginSenha={loginSenha}
      setLoginSenha={setLoginSenha}
      mensagemLogin={mensagemLogin}
      fazerLogin={fazerLogin}
    />
  );
}
  return (

    <div className="layout">

      <Sidebar
      menu={menu}
      setMenu={setMenu}
      logout={sair}
     />
      <main className="main">

        <header className="topbar">

          <div>

            <h1>RH Fênix Enterprise</h1>

            <span>
              Logado como {usuario?.nome}
            </span>

          </div>

        </header>

{menu === 'dashboard' && (
  <Dashboard
    token={token}
    sair={sair}
  />
)}

        {menu === 'colaboradores' && (

          <div className="content">

            <div className="page-header">

              <h2>Colaboradores</h2>

              <button
                className="primary"
                onClick={() => {
                  setModalAberto(true);
                  setAbaModal('dados');
                }}
              >
                + Novo Colaborador
              </button>

            </div>

            <div className="table-container">

              <table>

                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Matrícula</th>
                    <th>Biometria</th>
                    <th>Ações</th>
                  </tr>
                </thead>

                <tbody>

                  {colaboradores.map((colaborador) => (

                    <tr key={colaborador.id}>

                      <td>{colaborador.nome}</td>
                      <td>{colaborador.cpf || '-'}</td>
                      <td>{colaborador.matricula || '-'}</td>

                      <td>
                        {colaborador.possui_biometria
                          ? 'Cadastrada'
                          : 'Pendente'}
                      </td>

                      <td>

                        <button
                          className="small"
                          onClick={() => {

                            setColaboradorSelecionado(
                              colaborador
                            );

                            setAbaModal('biometria');

                            setModalAberto(true);

                          }}
                        >
                          Biometria
                        </button>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>
        )}

        {menu === 'ponto' && (

          <div className="content">

            <div className="page-header">
              <h2>Controle de Ponto Facial</h2>
            </div>

            <div className="biometria-box">

              <p>
                Posicione o rosto na câmera para registrar o ponto.
              </p>


<div className="camera-wrapper">

  <video
    ref={videoRef}
    autoPlay
    playsInline
    muted
    className="camera"
  />

  <div className="face-overlay">

    <div className="face-frame"></div>

    <div className="face-status">
      {faceStatus}
    </div>

  </div>

</div>

              <div className="actions">

                <button onClick={iniciarCamera}>
                  Ativar Câmera
                </button>

                <button
                  className="primary"
                  onClick={reconhecerFace}
                >
                  Reconhecer e Bater Ponto
                </button>

              </div>

              {mensagemPonto && (
                <p className="modal-message">
                  {mensagemPonto}
                </p>
              )}

            </div>

          </div>
        )}

{menu === 'relatorios' && (
  <Relatorios
    token={token}
    sair={sair}
  />
)}

{menu === 'configuracoes' && (
  <Configuracoes />
)}

      </main>
    </div>
  );
}

export default App;
